

























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { cloneDeep } from 'lodash';
const validateGroup: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('请选择大象群'));
    }
    return callback();
};
const validateCti: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('请选择TT关联目录'));
    }
    return callback();
};
const validateMessage: Function = (_rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入消息描述'));
    }
    return callback();
};
@Component({
    components: {}
})
export default class EditGroupRobotModal extends Vue {
    @Prop({ default: false })
    visible: boolean;
    @Prop()
    data: CommonTypes.mapObject;

    showModal: boolean = false;
    btnLoading: boolean = false;
    isGroupChanged: boolean = false;
    defaultKeyword: string = '@TT';
    catalogList: CommonTypes.RgUserItem[] = [];
    relatedCtiList: CommonTypes.mapObject[] = [];
    keywordList: CommonTypes.mapObject[] = [];
    settingDetail: CommonTypes.mapObject = {};
    xmGroupOptions: Array<CommonTypes.XmGroup> = [];
    recentXmGroupOptions: Array<CommonTypes.XmGroup> = [];
    ruleCustom = {
        dxGroupId: [{ validator: validateGroup, trigger: 'blur', required: true }],
        relatedItemId: [{ validator: validateCti, trigger: 'blur', required: true }],
        groupReplyContent: [{ validator: validateMessage, trigger: 'blur', required: true }]
    };
    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
    }
    @Watch('data', { immediate: true, deep: true })
    onDataChanged() {
        if (this.data.id) {
            this.settingDetail = cloneDeep(this.data);
            this.formatKeywordList(this.settingDetail.keywords);
        } else {
            this.settingDetail = {
                keywords: [this.defaultKeyword],
                minute: 1,
                groupReplyContent: 'TT创建成功！请耐心等待值班同学解答您的问题~',
                enableGroupReply: true,
                listenerRangeType: 'single'
            };
            this.keywordList = [
                {
                    label: this.defaultKeyword,
                    value: this.defaultKeyword,
                    closable: false,
                    disabled: true
                }
            ];
        }
    }
    created() {
        this.getRecentXmGroupList();
        this.getCtiByRgUnfold();
    }
    formatKeywordList(value) {
        this.keywordList = value.map(item => {
            return {
                label: item,
                value: item,
                closable: item !== this.defaultKeyword,
                disabled: item === this.defaultKeyword
            };
        });
    }
    onKeywordchanged(value) {
        this.formatKeywordList(value);
    }
    onGroupChanged() {
        this.isGroupChanged = true;
    }
    close() {
        this.$emit('update:visible', false);
    }

    submit() {
        (this.$refs.robotSettingForm as any).validate(async valid => {
            if (valid) {
                this.editGroup();
            }
        });
    }
    async searchMyXmGroupList(query: string) {
        if (!query) {
            return;
        }
        const res = await api.rgApi.searchXmGroupByKeyword(query);
        const { code, data } = res;
        if (code === 200 && Array.isArray(data.items)) {
            const dxGroupId = [...this.checkedXmGroupOptions.map(item => item.xmGroupId), ...data.items.map(item => item.xmGroupId)];
            const computedOptions = [...this.checkedXmGroupOptions, ...data.items].filter((item, index) => {
                return dxGroupId.indexOf(item.xmGroupId) === index;
            });
            this.xmGroupOptions = computedOptions;
        }
    }
    async getRecentXmGroupList() {
        const res = await api.rgApi.getRecentXmGroupList();
        if (res.code === 200) {
            // NOTE: 合并已选中的群聊 和 最近群聊，去重后展示出来
            const dxGroupId = [...this.checkedXmGroupOptions.map(item => item.xmGroupId), ...res.data.items.map(item => item.xmGroupId)];
            this.recentXmGroupOptions = res.data.items;
            this.xmGroupOptions = [...this.checkedXmGroupOptions, ...res.data.items].filter((item, index) => {
                return dxGroupId.indexOf(item.xmGroupId) === index;
            });
        }
    }
    async getCtiByRgUnfold() {
        // 直接展示所有数据，不考虑分页
        try {
            const res = await api.rgApi.getCtiByRgUnfold({
                cn: 1,
                sn: 999,
                rgId: this.rgId
            });
            const { code, data } = res;
            if (code === 200) {
                this.catalogList = data.items || [];
            }
        } catch (e) {
            console.log(e);
        }
    }
    async editGroup() {
        this.btnLoading = true;
        const apiName = this.settingDetail.id ? 'update' : 'create';
        try {
            const res = await api.rgApi[`${apiName}DxGroupListener`]({
                id: apiName === 'update' ? this.settingDetail.id : null,
                dxGroupId: this.settingDetail.dxGroupId,
                keywords: this.settingDetail.keywords,
                listenerRangeType: this.settingDetail.listenerRangeType,
                enableGroupReply: this.settingDetail.enableGroupReply,
                groupReplyContent: this.settingDetail.groupReplyContent,
                relatedItemId: this.settingDetail.relatedItemId,
                settingStatus: this.settingDetail.id ? this.settingDetail.settingStatus : 1,
                rgId: this.rgId,
                features: {
                    multiPre: this.settingDetail.minute.toString()
                }
            });
            const { code } = res;
            if (code === 200) {
                this.btnLoading = false;
                const idEdit = !!this.settingDetail.id;
                this.$emit('success', this.settingDetail.dxGroupId, idEdit ? this.isGroupChanged : true);
                this.$mtd.message.success(this.data.dxGroupId ? '编辑成功！' : '创建成功！');
            }
        } catch (error) {
            this.btnLoading = false;
        }
    }
    get checkedXmGroupOptions() {
        return this.xmGroupOptions.filter(item => this.settingDetail.dxGroupId === item.xmGroupId);
    }
    get title() {
        return this.data.dxGroupId ? '编辑群配置' : '新增群配置';
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
